<template>
  <div class="job-application-languages cell" v-if="require_languages">
    <div class="field">
      <label for="posting-languages">Languages <sup>*</sup></label>
      <div id="posting-languages" class="field__wrapper">
        Please specify any languages you speak, read or write.

        <div class="posting-languages-block" :key="index" v-for="(language, index) in languages">
          <div class="grid-x grid-margin-x">
            <div class="cell tablet-6">
              <input type="text" v-model="language.language" placeholder="Enter Language" :name="getLanguageFieldName(index)" :readonly="language.is_default">
              <input type="hidden" v-model="language.is_default" :name="getDefaultLanguageFieldName(index)" v-if="language.is_default">
              <button type="button" class="remove-language" @click="removeLanguage(index)" v-if="!language.is_default" v-show="index > 0">&times; Remove</button>
            </div>

            <div class="cell tablet-6">
              <ul class="posting-languages">
                <li class="field checkbox" :key="type" v-for="type in types">
                  <input :id="getCheckboxFieldId(index, type)" type="checkbox" :name="getCheckboxFieldName(index, type)" v-model="language[type]" @change="language[type] = $event.target.checked">
                  <label :for="getCheckboxFieldId(index, type)">{{ type.charAt(0).toUpperCase() + type.slice(1) }}</label>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <button type="button" class="btn btn--small" @click="addLanguage">Add Language</button>
        <input type="hidden" name="HasLanguages" value="1">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobApplicationLanguages',

  data() {
    return {
      postingId: null,
      require_availability: null,
      require_languages: null,
      languages: [],
      valid: true,
      types: [
        'speak',
        'read',
        'write'
      ]
    }
  },

  watch: {
    languages: function () {
    }
  },

  methods: {
    setPosting: function (data) {
      this.postingId = data.id
      this.require_availability = data.require_availability
      this.require_languages = data.require_languages

      for (const lang of data.default_languages) {
        this.languages.push({
          language: lang,
          is_default: true,
          speak: false,
          read: false,
          write: false
        })
      }

      if (data.default_languages.length === 0) {
        this.addLanguage()
      }
    },

    addLanguage: function () {
      this.languages.push({
        language: '',
        is_default: false,
        speak: false,
        read: false,
        write: false
      })
    },

    removeLanguage: function (index) {
      const languages = [...this.languages]
      languages.splice(index, 1)

      this.languages = languages
    },

    getDefaultLanguageFieldName: function (index) {
      return `languages[${index}][default]`
    },

    getLanguageFieldName: function (index) {
      return `languages[${index}][name]`
    },

    getCheckboxFieldId: function (index, name) {
      return `languages-${index}-${name}`
    },

    getCheckboxFieldName: function (index, name) {
      return `languages[${index}][${name}]`
    }
  }
}
</script>
